import React from 'react'

//import mouse from './../../UI/animation/Mouse_clic.svg'
import bolita from './../../UI/animation/bolita.svg'

interface Props {
  openScene: boolean,
  showDrag: boolean,
  isPortrait: boolean
}

interface State {
  showDragAnimation: boolean
}

class DragTablets extends React.Component<Props,State>{
  constructor(props: Props){
    super(props);
    this.state = {
      showDragAnimation: true
    }
  }

  componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any): void {
    if(prevProps.openScene !== this.props.openScene && this.props.openScene){
      setTimeout(() => {
        this.setState({
          showDragAnimation: true
        })
      }, 9000)
    }
  }
  
  render(): React.ReactNode {
      return(
        <div className={`drag-animation-container ${(this.state.showDragAnimation && this.props.openScene && this.props.showDrag) ? 'fade-in':'fade-out'} ${this.props.isPortrait ? 'drag-animation-container-portrait':''}`}>
          <div className='drag-animation-container-main'>
            <img src={bolita} alt='' className='mouse mouse-move tablets mouse-touch'/>
            <div className='drag-animation-text tablets-text'>Desliza para rotar 360°</div>
          </div>
          <div className='drag-hr'></div>
          <div className='drag-animation-container-main'>
            <img src={bolita} alt='' className='mouse-center-top tablets touch-center-top'/>
            <img src={bolita} alt='' className='mouse-center-bottom tablets touch-center-bottom'/>
            <div className='drag-animation-text'>pellizca para acercar o alejar el modelo</div>
          </div>
        </div>
      )
  }
}

export default DragTablets